/***
 * 客户流失分析
 */
import { post, get, postJson, put } from '../axios'
const RESOURCE_BASE_PATH = '/customer-analysis'

// 客户流失分析
export const lossAnalysis = p => get(`${RESOURCE_BASE_PATH}/lossAnalysis`, p);

// 导出数据
export const exportData = p => get(`${RESOURCE_BASE_PATH}/lossAnalysis/export`, p);

export const exportDataOne = p => get(`/customer-analysis/lossAnalysis/export`, p);